// extracted by mini-css-extract-plugin
export default {"button":"ButtonLink_button__xPWFi","type2":"ButtonLink_type2__UtUwm"};